import React from 'react';

import hiring from '../../../images/hiring.svg';

import { FOHImage } from '../../ingredients';

export const FOHJobsIcon = () => (
  <FOHImage source={{ uri: hiring }} style={{ width: 32, height: 24 }} />
);
